"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Silent"] = 0] = "Silent";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Breadcrumb"] = 3] = "Breadcrumb";
    LogLevel[LogLevel["Info"] = 4] = "Info";
    LogLevel[LogLevel["Verbose"] = 5] = "Verbose";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
var Logger = /** @class */ (function () {
    function Logger(rawContext, logHandlers, opts) {
        if (rawContext === void 0) { rawContext = ''; }
        if (logHandlers === void 0) { logHandlers = new Map(); }
        this.rawContext = rawContext;
        this.logHandlers = logHandlers;
        this.opts = opts;
        this.verbose = this.runHandlers(LogLevel.Verbose, 'verbose');
        this.info = this.runHandlers(LogLevel.Info, 'info');
        this.breadcrumb = this.runHandlers(LogLevel.Breadcrumb, 'breadcrumb');
        this.warn = this.runHandlers(LogLevel.Warn, 'warn');
        this.error = this.runHandlers(LogLevel.Error, 'error');
    }
    Logger.prototype.withContext = function (additionalContext) {
        var context = this.rawContext ? "".concat(this.rawContext, ":").concat(additionalContext) : additionalContext;
        return new Logger("".concat(context), this.logHandlers, this.opts);
    };
    Logger.prototype.registerLogHandlers = function () {
        var _this = this;
        var logHandlers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            logHandlers[_i] = arguments[_i];
        }
        var id = Logger.logHandlerId++;
        this.logHandlers.set(id, logHandlers);
        return function () { return _this.logHandlers.delete(id); };
    };
    Logger.prototype.runHandlers = function (logLevel, func) {
        var _this = this;
        return function () {
            var messages = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                messages[_i] = arguments[_i];
            }
            try {
                Array.from(_this.logHandlers.values())
                    .flat()
                    .forEach(function (handler) {
                    var _a;
                    if (handler.logLevel < logLevel) {
                        return;
                    }
                    var handlerFunction = handler[func];
                    if (!handlerFunction) {
                        return;
                    }
                    var args = ((_a = _this.opts) === null || _a === void 0 ? void 0 : _a.disablePrefix) ? __spreadArray([], messages, true) : __spreadArray([_this.getPrefix(logLevel)], messages, true);
                    handlerFunction.apply(void 0, args);
                });
            }
            catch (e) {
                console.error("Error when logging ".concat(func, " ").concat(e));
            }
        };
    };
    Logger.prototype.getPrefix = function (logLevel) {
        var timestamp = "[".concat(new Date().toISOString(), "]");
        var context = "[".concat(this.rawContext, "]");
        var logLevelKey = "[".concat(LogLevel[logLevel].toUpperCase(), "]");
        return [timestamp, context, logLevelKey].join(' ');
    };
    Logger.logHandlerId = 0;
    return Logger;
}());
exports.Logger = Logger;
